"use client"

import { datadogRum } from "@datadog/browser-rum"

import { PSEUDO_ID_COOKIE } from "@lib/constants"
import { getSessionCookie } from "@lib/util/get-session-cookie-client"

export default function DatadogInit() {
  const datadogApplicationId = process.env.NEXT_PUBLIC_DATADOG_RUM_APPLICATION_ID
  const datadogClientToken = process.env.NEXT_PUBLIC_DATADOG_RUM_CLIENT_TOKEN
  const datadogEnv = process.env.NEXT_PUBLIC_DATADOG_RUM_ENV || "development"
  const sessionSampleRate = process.env.NEXT_PUBLIC_DATADOG_RUM_SESSION_SAMPLE_RATE
    ? Number(process.env.NEXT_PUBLIC_DATADOG_RUM_SESSION_SAMPLE_RATE)
    : 100
  const sessionReplaySampleRate = process.env.NEXT_PUBLIC_DATADOG_RUM_SESSION_REPLAY_SAMPLE_RATE
    ? Number(process.env.NEXT_PUBLIC_DATADOG_RUM_SESSION_REPLAY_SAMPLE_RATE)
    : 100

  if (typeof window !== "undefined" && datadogApplicationId && datadogClientToken) {
    datadogRum.init({
      applicationId: datadogApplicationId,
      clientToken: datadogClientToken,
      site: "datadoghq.com",
      service: "marketplace-storefront",
      env: datadogEnv,
      version: process.env.NEXT_PUBLIC_APP_VERSION,
      sessionSampleRate,
      sessionReplaySampleRate,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: "mask-user-input",
      allowedTracingUrls: [/^https?:\/\/.*\.nelo\.co/],
      enableExperimentalFeatures: ["feature_flags"],
    })

    const pseudoId = getSessionCookie(PSEUDO_ID_COOKIE)
    if (pseudoId) {
      datadogRum.setUser({
        id: pseudoId,
      })
    }

    datadogRum.startSessionReplayRecording()
  }

  return null
}
